import { createRouter, createWebHistory } from 'vue-router'

const routes = [
  {
    path: '/goodsInfo', //商品详情
    name: 'goodsInfo',
    component: () => import(/* webpackChunkName: "goodsInfo" */ '../views/goodsInfo.vue')
  },
  {
    path: '/shopList', //店铺详情
    name: 'shopList',
    component: () => import(/* webpackChunkName: "shopList" */ '../views/shopList.vue')
  },
  {
    path: '/nicheInfo', //商机详情
    name: 'nicheInfo',
    component: () => import(/* webpackChunkName: "nicheInfo" */ '../views/nicheInfo.vue')
  },
  {
    path: '/mainteNance', //维修保养详情
    name: 'mainteNance',
    component: () => import(/* webpackChunkName: "mainteNance" */ '../views/mainteNance.vue')
  },
  {
    path: '/userAgreement',  //用户注册协议
    name: 'userAgreement',
    component: () => import(/* webpackChunkName: "userAgreement" */ '../views/userAgreement.vue')
  },
  {
    path: '/privacyAgreement', //用户隐私协议
    name: 'privacyAgreement',
    component: () => import(/* webpackChunkName: "privacyAgreement" */ '../views/privacyAgreement.vue')
  },
  {
    path: '/memberAgreement', //会员服务协议
    name: 'memberAgreement',
    component: () => import(/* webpackChunkName: "memberAgreement" */ '../views/memberAgreement.vue')
  },
  {
    path: '/exhibitionAgreement', //展会协议
    name: 'exhibitionAgreement',
    component: () => import(/* webpackChunkName: "exhibitionAgreement" */ '../views/exhibitionAgreement.vue')
  },
  {
    path: '/upExample', //上传示例
    name: 'upExample',
    component: () => import(/* webpackChunkName: "upExample" */ '../views/upExample.vue')
  },
  {
    path: '/shopGoods', //店铺搜索页
    name: 'shopGoods',
    component: () => import(/* webpackChunkName: "shopGoods" */ '../views/shopGoods.vue')
  },
  {
    path: '/systemNotice', //系统通知详情
    name: 'systemNotice',
    component: () => import(/* webpackChunkName: "systemNotice" */ '../views/systemNotice.vue')
  },
  {
    path: '/agreementList', //协议列表
    name: 'agreementList',
    component: () => import(/* webpackChunkName: "agreementList" */ '../views/agreementList.vue')
  },
  {
    path: '/myInfo', //关于我们
    name: 'myInfo',
    component: () => import(/* webpackChunkName: "myInfo" */ '../views/myInfo.vue')
  },
  {
    path: '/download', //APP下载页
    name: 'download',
    meta: { title: '下载奢哈哈-更好用的二奢进销存平台' },
    component: () => import(/* webpackChunkName: "download" */ '../views/download.vue')
  },
  {
    path: '/join', //店铺邀请成员加入
    name: 'join',
    component: () => import(/* webpackChunkName: "download" */ '../views/join.vue')
  }
]
const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

router.beforeEach((to, from, next) => {
  if (to.meta.title) {
      document.title = to.meta.title
  }
  next()
})

export default router
